import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import {
  CreateWebhookParams,
  CreateWebhookResponse,
  DeleteWebhookParams,
  DeleteWebhookResponse,
  GetEventTypesResponse,
  GetWebhooksParams,
  GetWebhooksResponse,
  TestWebhookParams,
  UpdateWebhookParams,
  UpdateWebhookResponse,
  WebhookTriggerResponse,
} from '../dtos';
@Injectable({
  providedIn: 'root',
})
export class WebhooksService {
  constructor(private readonly apiService: ApiService) {}

  /**
   * permissions: {mode: "+r", res: "webhooks.*"}
   */
  getWebhooks(
    getWebhooksParams: GetWebhooksParams
  ): Observable<GetWebhooksResponse> {
    let params = this.apiService.queryParams(getWebhooksParams);
    return this.apiService.get('/v2/webhooks', params);
  }

  /**
   * permissions: {mode: "+c", res: "webhooks.*"}
   */
  createWebhook(
    createWebhookParams: CreateWebhookParams
  ): Observable<CreateWebhookResponse> {
    return this.apiService.post('/v2/webhook', createWebhookParams);
  }

  /**
   * permissions: {mode: "+u", res: "webhooks.*"}
   */
  updateWebhook(
    updateWebhookParams: UpdateWebhookParams
  ): Observable<UpdateWebhookResponse> {
    return this.apiService.put(
      `/v2/webhooks/${updateWebhookParams.webhookId}`,
      updateWebhookParams
    );
  }

  /**
   * permissions: {mode: "+d", res: "webhooks.*"}
   */
  deleteWebhook(
    deleteWebhookParams: DeleteWebhookParams
  ): Observable<DeleteWebhookResponse> {
    let params = this.apiService.queryParams(deleteWebhookParams);
    return this.apiService.delete(
      `/v2/webhooks/${deleteWebhookParams.webhookId}`,
      params
    );
  }

  /**
   * permissions: {mode: "+r", res: "webhooks.*"}
   */
  getEventTypes(): Observable<GetEventTypesResponse> {
    return this.apiService.get(`/v2-internal/webhooks/events/types`);
  }

  /**
   * permissions: {mode: "+r", res: "webhooks.*"}
   */
  testWebhook(
    testWebhookParams: TestWebhookParams
  ): Observable<WebhookTriggerResponse> {
    return this.apiService.post(
      `/v2/webhooks/${testWebhookParams.webhookId}/event/${testWebhookParams.eventType}`
    );
  }
}
